import React from "react";
import styles from "./Transfers.module.scss";
import { Wrapper } from "../Wrapper";

export const Transfers: React.FunctionComponent = () => {
  return (
    <div
      id="transfers"
      className={styles.transfers}
      // style={{
      //   backgroundImage: `url(${bg})`,
      // }}
    >
      <Wrapper>
        <h1>Transfers</h1>

        <div className={styles.body}></div>
      </Wrapper>
    </div>
  );
};
